export default {
    isSelected: true,
    boxes: [
        // Product Selector
        {
            // bannerText: "ActionJak",
            heading: "actionjak-header",
            text: "actionjak-desc",
            image: "Nook_ActionJac.jpg",
            apiName: "Selector",
            toolType: "Selector",
            isSelected: false
        },

        // Old Product Selector
        {
            // bannerText: "product-selector",
            heading: "thomson-screw-jacks-header",
            text: "thomson-screw-jacks-desc",
            image: "Thomson_ScrewJacks.png",
            apiName: "Old-Selector",
            toolType: "Old-Selector",
            isSelected: false
        },

        // Contact Thomson
        {
            // bannerText: "contact-thomson",
            heading: "contact-thomson-heading",
            text: "",
            image: "Contact_Thomson.png",
            apiName: "ContactThomson",
            toolType: "ContactThomson",
            redirectUrl: "path.tlo.contact-us",
            isSelected: false
        },
    ]
}